const priorityGroups = [
  [
    'M.I.T. Muzaffarpur',
    'B.C.E. Bhagalpur',
    'Nalanda College. Of Engg,Chandi',
    'B.C.E. Bakhtiyarpur',
  ],
  [
    'G.C.E. Gaya',
    'D.C.E. Darbhanga',
    'M..C.E. Motihari',
    'L.N.J.P.I.T. Technology. Chapra',
    'S.I.T. Sitamarhi',
  ],
  [
    'K.C.E., Katihar',
    'Purnea College Of Engg.',
    'Saharsa College Of Engg.',
    'Supaul Engg. College, Supaul',
    'B.P.M.C.E. Madhepura',
    'R.R.S.D.C.E, Begusarai',
  ],
  [
    'Shri Phanishwar Nath Renu Engg. College, Araria',
    'Govt. Engg. College, Arwal',
    'Govt. Engg. College, Aurangabad',
    'Govt. Engg. College, Banka',
    'Govt. Engg. College, Buxar',
    'Govt. Engg. College, Gopalganj',
    'Govt. Engg. College, Jamui',
    'Govt. Engg. College, Jehanabad',
    'Govt. Engg. College, Kaimur',
    'Govt. Engg. College, Khagaria',
    'Govt.Engg. College Kishanganj',
    'Govt. Engg. College Of Lakhisarai',
    'Govt. Engg. College, Madhubani',
    'Govt. Engg.College Munger',
    'Govt. Engg. College, Nawada',
    'Govt. Engg. College, Sheikhpura',
    'Govt Engg. College Sheohar',
    'Govt. Engg. College, Siwan',
    'Govt. Engg. College, Vaishali',
    'Govt Engg College W. Champaran',
  ],
];

const priorityMap = priorityGroups.reduce((map, group, groupIndex) => {
  group.forEach((college, collegeIndex) => {
    map.set(college, groupIndex * 100 + collegeIndex);
  });

  return map;
}, new Map());

export const getCollegePriority = (college) => {
  return priorityMap.get(college) ?? 9999;
};

export const sortByCollegePriority = (results) => {
  return [...results].sort((first, second) => {
    const priorityDifference =
      getCollegePriority(first.college) - getCollegePriority(second.college);

    if (priorityDifference !== 0) {
      return priorityDifference;
    }

    const branchPriorityDifference =
      (first.branchPriority ?? 9999) - (second.branchPriority ?? 9999);

    if (branchPriorityDifference !== 0) {
      return branchPriorityDifference;
    }

    if (first.status !== second.status) {
      const statusOrder = {
        SAFE: 0,
        BORDERLINE: 1,
        'LOW CHANCE': 2,
        'NO CHANCE': 3,
      };
      return statusOrder[first.status] - statusOrder[second.status];
    }

    return second.gap - first.gap;
  });
};
